import React from "react";
import "react-tabs/style/react-tabs.css";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Col } from "reactstrap"; //CardImg,
import { Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import * as moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { IconButton } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

class TargetList extends React.Component {
  state = {};
  constructor(props) {
    super(props);
    this.state = {		
		tabs: ["", "", ""],
		tabPanel: ["", "", ""],
		tabPanel0: "",
		tabPanel1: "",
		tabPanel2: "",
		modal: false,
		"aStatus": "",
		userData: [] 
    };
	
    // this.submitHandler = this.submitHandler.bind(this);
  }

  nextPath(path, value) {
    this.props.history.push({ pathname: path, data: value, state: { data: value } });
  }

  componentDidMount() {
	// alert(this.state.rstatus)
    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole === "Marketing") {
		if(this.props.location.data){
		// if(this.state.rstatus){
			this.setState({  "aStatus": this.props.location.data  })
			const postCustData = { "userid": this.props.userId, "status": this.props.location.data }
			const url = process.env.REACT_APP_NODE_ENV + "/api/market-target-lead/list";
			  fetch(url, {
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
				},
				body: JSON.stringify(postCustData)
				}).then(
				response => {
					// console.log(response)
				  return response.json();
				}
			  ).then(data => {
				  console.log(data)
				this.setState({ userData: data })
			  })
		}else{
			const postCustData = { "userid": this.props.userId, "status": "" }
			const url = process.env.REACT_APP_NODE_ENV + "/api/market-target-lead/list";
			  fetch(url, {
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
				},
				body: JSON.stringify(postCustData)
				}).then(
				response => {
					// console.log(response)
				  return response.json();
				}
			  ).then(data => {
				  console.log(data)
				this.setState({ userData: data })
			  })
		}
    }
	
  }

	
  triggerDelete = (id) => {
	  // alert(id)
	if(window.confirm("Are you sure you want to delete?")){
		const LeadData = {
		  id: id
		};
		fetch(process.env.REACT_APP_NODE_ENV + '/api/market-target-lead/delete', {
		method: 'POST',
		headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
		},
		  body: JSON.stringify(LeadData)
		}).then(response => { if (response.ok) {
			this.componentDidMount()
		} }).then(data => console.log(data)).catch((err) => console.log(err))
	}
  };
  
	onstatus = (event) => {
		this.setState({  "aStatus": event.target.value  })
		const postCustData = { "userid": this.props.userId, "status": event.target.value }
		const url = process.env.REACT_APP_NODE_ENV + "/api/market-target-lead/list";
		  fetch(url, {
			method: 'POST',
			headers: {
			  'Content-Type': 'application/json',
			  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
			},
			body: JSON.stringify(postCustData)
			}).then(
			response => {
				// console.log(response)
			  return response.json();
			}
		  ).then(data => {
			  console.log(data)
			this.setState({ userData: data })
		  })
	}
// triggerDelete = (id)
  render() {
    // let userdatas = this.state.userData.map((data, index) => {
    //   return (
    //     <tr key={index}><td>{index + 1}</td><td>{data.id}</td>
    //       <td>{data.apartmentName}</td>
    //       <td>{data.apartmentPhoneNo}</td>
    //       <td>{data.doorNo + ", " + data.streetName + ", " + data.area}</td>
    //       <td> {data.city}</td>
    //       <td> {data.landmark}</td>
    //       <td><Button variant="outline-success" onClick={() => this.nextPath("/aprt-customer/customer-details", data.id)} >
    //         Details </Button></td></tr>)
    // });

    let dataArr = [];
	if(this.state.userData.length > 0){
    this.state.userData.map((data) => {
		let ccfollowdate = ""
		if(data.Follow_up_Date){
			ccfollowdate = moment(data.Follow_up_Date).format("DD-MM-YYYY")
		}
		let mdData = [
			data.Source, data.Category,data.Client_Name, data.Phone_number, data.Location,data.Status, ccfollowdate, data
		];
      dataArr.push(mdData)
      return null;
    });
	} 


    const columns = [
      {
        name: "Source",
        label: "source",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "Category",
        label: "Category",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "ClientName",
        label: "Client Name",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "PhoneNumber",
        label: "Phone Number",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "Location",
        label: "Location",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "Status",
        label: "Status",
        options: {
           filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
			  // console.log(value)
            return (
              <>
				
				{ (value === "Cold") && <Button variant="secondary">{value}</Button> }
				{ (value === "Warm") && <Button variant="warning">{value}</Button> }
				{ (value === "Hot") && <Button variant="primary">{value}</Button> }
				{ (value === "Converted") && <Button variant="success">{value}</Button> }
				{ (value === "Not Interested") && <Button variant="danger">{value}</Button> }
				
              </>
            );
          }
        }
      },
	  {
        name: "Follow_up_Date",
        label: "Follow-Up Date",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
          download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
			  // console.log(value)
            return (
              <>
				<Tooltip title="View"><IconButton onClick={() => window.open("/market-target-lead/customer-view?id="+value.id, "_blank")}><VisibilityIcon /></IconButton></Tooltip>
				<Tooltip title="Edit"><IconButton onClick={() => window.open("/market-target-lead/customer-edit?id="+value.id, "_blank")}><EditIcon /></IconButton></Tooltip>
				<Tooltip title="Delete"><IconButton onClick={() => this.triggerDelete(value.id)}><DeleteForeverIcon /></IconButton></Tooltip>
              </>
            );
          }
        }
      }
    ];


    const options = {
     filterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: false,
      expandableRowsOnClick: false,
	  
      downloadOptions: {
        filename: 'My Leads.csv',
      },
      // ,
      // onRowsDelete: (rowsDeleted) => {
      //   for (var key in rowsDeleted.data) {
      //     console.log(rowsDeleted.data[key].index)
      //     this.delete(dataArr[rowsDeleted.data[key].index].id)
      //   }
      // }
    };

    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole === "Marketing") {
      return (
        <>
			
		<div class="w-100 p-3">
          <Breadcrumb>
            <Breadcrumb.Item active>My Leads</Breadcrumb.Item>
          </Breadcrumb>
		</div>
		<div className="form-group row" style={{ backgroundColor: "white", padding:"10px"}}>
			<div className="col-lg-5" style={{ padding:"10px"}}>
				<select name="aStatus" id="uStatus"  className="form-control" value={this.state.aStatus} onChange={this.onstatus}>
					<option value="">All</option>
					<option value="Cold">Cold</option>
					<option value="Warm">Warm</option>
					<option value="Hot">Hot</option>
					<option value="Converted">Converted</option>
					<option value="Not Interested">Not Interested</option>
					<option value="Pipe Line">Pipe Line</option>
				</select>
			</div>	
			<div className="col-lg-5">
			</div>
			<div className="col-lg-2" style={{ padding:"10px"}}>
			  <div className="form-group">
				<Button variant="outline-success"  class="pull-right" onClick={() => this.nextPath("/market-target-lead/customer-create", "")}> Add Lead </Button>
			  </div>
			</div>
		</div>
		
		
		
          <div style={{ marginTop: "10px" }}>
           
            <MUIDataTable
              title={"My Leads"}
              data={dataArr}
              columns={columns}
              options={options} 
			  />

          </div>
        </>
      );
    } else {
      return (<></>);
    }

  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id
  }
}

export default connect(
  mapStateToProps,
  null
)(TargetList)
